import { Link, useNavigate, useLocation } from "react-router-dom";
import { Box, Button, Container, Grid2, Typography, TextField, Card, CardContent, Alert } from '@mui/material';
import { useAuth } from '../AuthContext';
import { useState } from "react";

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth();
  const [formLoading, setFormLoading] = useState(false);
  const [formError, setFormError] = useState('');

  const from = location.state?.from?.pathname || "/account";

  function handleSubmit(event) {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    const email = formData.get("email");
    const password = formData.get("password");
    
    if (!email || !password) {
      setFormError('A username or password is required');
      return;
    }
    setFormLoading(true);

    auth.signin({ email, password }).then(res => {
      console.log('success!', res);
      if (res?.error) {
        setFormError(res.error);
        return;
      }
      navigate(from, { replace: true });
    }).catch(error => {
      // error)
      console.log('error', error);
      setFormError(error.message);
    }).finally(() => {
      setFormLoading(false);
    });
    // auth.signin(username, () => {
    //   // Send them back to the page they tried to visit when they were
    //   // redirected to the login page. Use { replace: true } so we don't create
    //   // another entry in the history stack for the login page.  This means that
    //   // when they get to the protected page and click the back button, they
    //   // won't end up back on the login page, which is also really nice for the
    //   // user experience.
    //   navigate(from, { replace: true });
    // });
  }

  return (
    <Container maxWidth="sm" sx={{ p: 3 }}>
      <Typography variant="h3">Log In</Typography>
      <Typography variant="body2" color="textSecondary" sx={{ my: 3 }}>Enter your email address and password to manage your OpenGolfSim account</Typography>

      <form onSubmit={handleSubmit}>
        <Grid2 container direction="column" spacing={3}>
          <Grid2>
            <TextField disabled={formLoading} name="email" label="Email" fullWidth required />
          </Grid2>
          <Grid2>
            <TextField disabled={formLoading} name="password" label="Password" type="password" fullWidth required />
          </Grid2>
        </Grid2>
        <Grid2 container sx={{ mt: 2 }}>
          <Grid2 sx={{ flexGrow: 1 }}>
            <Button color="inherit" disabled={formLoading} to="/password-reset" component={Link}>Forgot password?</Button>
          </Grid2>
          <Grid2>
            <Button disabled={formLoading} type="submit" color="primary" variant="outlined">Login</Button>
          </Grid2>
        </Grid2>
        {formError ? (
          <Box>
            <Alert severity="error">{formError}</Alert>
          </Box>
        ) : null}
      </form>


      <Card sx={{ mt: 10 }}>
        <CardContent>
          <Box sx={{ textAlign: 'center' }}>
            <Typography>Don't have an account? Get started for free!</Typography>
            <Button to="/signup" component={Link} sx={{ mt: 2, mr: 1 }} color="secondary" variant="outlined">Create Free Account</Button>
          </Box>          
        </CardContent>
      </Card>
      
      {/* <form onSubmit={handleSubmit}>
        <label>
          Username: <input name="username" type="text" />
        </label>{" "}
        <button type="submit">Login</button>
      </form> */}
    </Container>
  );
}
